import { Directive, TemplateRef } from "@angular/core";

/**
 * This structural directive is used to mark an <ng-template> given to the Carousel component to indicate where they should go.
 *
 * Usage with <h-carousel> component :
 *
 * ```
 * <h-carousel>
 *   <div *slide></div>
 * </h-carousel>
 * ```
 */
@Directive({
    selector: "[hSlide], [slide]",
    exportAs: "slide",
    standalone: true,
})
export class CarouselPartDirective {
    constructor(public templateReference: TemplateRef<HTMLElement>) {}
}
